module.exports = __webpack_public_path__ + "static/media/2.5710cee4.png";